(function () {
    var autocomplete;

    var componentForm = {
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'short_name',
        postal_code: 'short_name'
    };

    function initAutocomplete() {
        var input = document.getElementById('route');

        autocomplete = new google.maps.places.Autocomplete(input, {types: ['geocode']});

        autocomplete.setFields(['address_components', 'geometry', 'place_id']);

        autocomplete.addListener('place_changed', fillInAddress);

        setTimeout(function(){
            $(input).attr('autocomplete', 'new-password');
            input.removeAttribute('placeholder');
        }, 1000);

    }

    function fillInAddress() {
        var place = autocomplete.getPlace();

        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();

        setInputs(place, lat, lng);

        for (var component in componentForm) {
            document.getElementById(component).value = '';
            document.getElementById(component).disabled = false;
        }

        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                var val = place.address_components[i][componentForm[addressType]];

                if(addressType === 'administrative_area_level_1') {
                    val = val.toLowerCase();
                } else if(addressType === 'route') {
                   var number = place.address_components[0].long_name;

                   if(number.length > 0) {
                       if(val !== number) {
                           val = number + " " + val;
                       }
                   }
                }

                document.getElementById(addressType).value = val;
                $('#' + addressType).parent().find('label').addClass('active');
                if(addressType === 'administrative_area_level_1') {
                    $('#' + addressType).material_select();
                    $('#' + addressType).parent().removeClass('error');
                }
                $('#' + addressType+'-error').remove();
            }
        }
        $("#locality").trigger('change');

        if (isInArray('properties', location.pathname.split("/")) && isInArray('overview', location.pathname.split("/"))) {
            MapController.PropertiesPin.setSelectedPin();
        } else if(isInArray('comps', location.pathname.split("/")) || isInArray('res_comps', location.pathname.split("/"))) {
            MapController.CompsPin.setSelectedPin();
        } else if(isInArray('evaluations', location.pathname.split("/")) || isInArray('res_evaluations', location.pathname.split("/"))) {
            if(isInArray('cost', location.pathname.split("/")) || isInArray('sales', location.pathname.split("/")) || isInArray('leaseComps', location.pathname.split("/")) || isInArray('capComps', location.pathname.split("/"))) {
                MapController.CompsPin.setSelectedPin();
            } else {
                MapController.EvaluationsPin.setSelectedPin();
            }
        }
    }

    function geolocate() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                var circle = new google.maps.Circle(
                    {center: geolocation, radius: position.coords.accuracy});
                autocomplete.setBounds(circle.getBounds());
            });
        }
    }

    function setInputs(place, lat, lng) {
        if ($('#google_place_id').length > 0) {
            $('#google_place_id').val(place.place_id);
        }

        if ($('input[name="listing[google_place_id]"]').length > 0) {
            $('input[name="listing[google_place_id]"]').val(place.place_id);
        }

        if ($('input[name="evaluation[google_place_id]"]').length > 0) {
            $('input[name="evaluation[google_place_id]"]').val(place.place_id);
        }

        if ($("input[name='evaluation[latitude]']").length > 0) {
            $("input[name='evaluation[latitude]']").val(lat);
        }

        if ($("input[name='evaluation[longitude]']").length > 0) {
            $("input[name='evaluation[longitude]']").val(lng);
        }

        if ($("input[name='listing[latitude]']").length > 0) {
            $("input[name='listing[latitude]']").val(lat);
        }

        if ($("input[name='listing[longitude]']").length > 0) {
            $("input[name='listing[longitude]']").val(lng);
        }

        if ($("input[name=latitude]").length > 0) {
            $("input[name=latitude]").val(lat);
        }

        if ($("input[name=longitude]").length > 0) {
            $("input[name=longitude]").val(lng);
        }

        if ($("input[name='map_pin_lat']").length > 0) {
            $("input[name='map_pin_lat']").val(lat);
        }

        if ($("input[name='map_pin_lng']").length > 0) {
            $("input[name='map_pin_lng']").val(lng);
        }

        if ($("input[name='listing[map_pin_lat]']").length) {
            $("input[name='listing[map_pin_lat]']").val(lat);
        }

        if ($("input[name='listing[map_pin_lng]']").length) {
            $("input[name='listing[map_pin_lng]']").val(lng);
        }

        if ($("input[name='evaluation[map_pin_lat]']").length) {
            $("input[name='evaluation[map_pin_lat]']").val(lat);
        }

        if ($("input[name='evaluation[map_pin_lng]']").length) {
            $("input[name='evaluation[map_pin_lng]']").val(lng);
        }
    }

    if (window.Geolocate === undefined) {
        window.Geolocate = {};
    }

    window.Geolocate.search = geolocate;
    window.Geolocate.autocomplete = initAutocomplete;
})();